export var DeviationTypes = /*#__PURE__*/ function(DeviationTypes) {
    DeviationTypes["UNKNOWN"] = "unknown";
    DeviationTypes["IMAGE"] = "image";
    DeviationTypes["JOURNAL"] = "journal";
    DeviationTypes["LITERATURE"] = "literature";
    DeviationTypes["FILM"] = "film";
    DeviationTypes["PDF"] = "pdf";
    DeviationTypes["POLL"] = "poll";
    DeviationTypes["COMMISSION"] = "commission";
    DeviationTypes["STATUS"] = "status";
    DeviationTypes["TIER"] = "tier";
    return DeviationTypes;
}({});
export var DeviationResourceType = /*#__PURE__*/ function(DeviationResourceType) {
    DeviationResourceType[DeviationResourceType["UNKNOWN"] = 0] = "UNKNOWN";
    DeviationResourceType[DeviationResourceType["ART"] = 1] = "ART";
    DeviationResourceType[DeviationResourceType["JOURNAL"] = 5] = "JOURNAL";
    DeviationResourceType[DeviationResourceType["SITE_POLL"] = 6] = "SITE_POLL";
    DeviationResourceType[DeviationResourceType["POLL"] = 14] = "POLL";
    DeviationResourceType[DeviationResourceType["COMMISSION"] = 66] = "COMMISSION";
    DeviationResourceType[DeviationResourceType["STATUS"] = 69] = "STATUS";
    DeviationResourceType[DeviationResourceType["STATUS_DEVIATION"] = 81] = "STATUS_DEVIATION";
    DeviationResourceType[DeviationResourceType["TIER"] = 82] = "TIER";
    return DeviationResourceType;
}({});
export var DeviationSuggestionReasons = /*#__PURE__*/ function(DeviationSuggestionReasons) {
    DeviationSuggestionReasons[DeviationSuggestionReasons["WatchingUser"] = 1] = "WatchingUser";
    DeviationSuggestionReasons[DeviationSuggestionReasons["WatchingGroup"] = 2] = "WatchingGroup";
    DeviationSuggestionReasons[DeviationSuggestionReasons["WatchingTopic"] = 3] = "WatchingTopic";
    DeviationSuggestionReasons[DeviationSuggestionReasons["Recommended"] = 4] = "Recommended";
    DeviationSuggestionReasons[DeviationSuggestionReasons["DailyDeviation"] = 5] = "DailyDeviation";
    DeviationSuggestionReasons[DeviationSuggestionReasons["NewDeviant"] = 6] = "NewDeviant";
    DeviationSuggestionReasons[DeviationSuggestionReasons["Popular"] = 7] = "Popular";
    DeviationSuggestionReasons[DeviationSuggestionReasons["Boosted"] = 8] = "Boosted";
    return DeviationSuggestionReasons;
}({});
export var DeviationMatureContentType = /*#__PURE__*/ function(DeviationMatureContentType) {
    DeviationMatureContentType["SAFE"] = "safe";
    DeviationMatureContentType["MODERATE"] = "moderate";
    DeviationMatureContentType["STRICT"] = "strict";
    return DeviationMatureContentType;
}({});
export var DeviationAccessSettingsType = /*#__PURE__*/ function(DeviationAccessSettingsType) {
    DeviationAccessSettingsType["ALL"] = "all";
    DeviationAccessSettingsType["FUTURE_ONLY"] = "future_only";
    DeviationAccessSettingsType["LIMITED_PAST_AND_FUTURE"] = "limited_past_and_future";
    return DeviationAccessSettingsType;
}({});
/**
 * What a deviation can be sold as.
 *
 * The mapped string values are exact matches for what the backend returns in {@link PapiDeviation}'s
 * extended.sellable_as field. Change them with caution.
 */ export var SellableAs = /*#__PURE__*/ function(SellableAs) {
    SellableAs["Adoptable"] = "adoptable";
    SellableAs["AdoptableResale"] = "adoptable_resale";
    SellableAs["Pcp"] = "pcp";
    return SellableAs;
}({});

//# sourceMappingURL=types.js.map